module.exports = __webpack_public_path__ + "static/img/title.768558a6.png";